export default __webpack_public_path__ + "static/media/pr_details1.d385d605.jpg";